<template>
  <div class="main">
    <div class="pageTitle">
      <p>组织</p>
    </div>
    <div style="clear:left; margin-top:20px;">
      <div class="tree">
        <div>
          <el-button size="small" @click="showOrganizationDialog" :disabled="disabledTreeButtons">添加子级</el-button>
          <el-button size="small" @click="editOrganization" :disabled="disabledTreeButtons">修改</el-button>
        </div>
        <!-- <div>
          <el-input v-model="filterText" autocomplete="off" size="mini"></el-input>
        </div> -->
        <div style="margin-top:20px;">
          <el-tree
            ref="tree"
            :key="tree_key"
            :data="treeData"
            node-key="id"
            :props="organizationTreeProps"
            :expand-on-click-node="false"
            default-expand-all
            :current-node-key="currentOrganizationNode"
            :filter-node-method="filterNode"
            :highlight-current="true"
            @node-click="organizationTreeNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span>
                    <span style="color:red" v-if="data.removed">（已停用）</span>
                  </span>
              </span>
            </el-tree>
        </div>
      </div>
      <div class="rightDiv">
        <el-form
          label-position="left"
          size="small"
          label-width="80px"
          class="searchForm"
          @submit.native.prevent
          :inline="true">
          <el-form-item label="关键字:">
            <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getUserList">查询</el-button>
            <el-button @click="showUserDialog">添加用户</el-button>
          </el-form-item>
        </el-form>
        <div class="tableContainer" style="top:40px;bottom:-75vh">
          <div class="tableContent">
            <el-table :data="userList" border stripe>
              <el-table-column type="index" width="50" label="NO" fixed="left"></el-table-column>
              <el-table-column prop="name" label="姓名" fixed="left">
                <template slot-scope="props">
                  <el-button
                    type="text"
                    size="mini"
                    @click="getUser(props.row)">{{props.row.name}}</el-button>
                    <span style="color:red" v-if="props.row.removed">（已停用）</span>
                </template>
              </el-table-column>
              <el-table-column prop="organizationName" label="组织机构"></el-table-column>
              <el-table-column prop="account" label="登录账户"></el-table-column>
              <!-- <el-table-column prop="Cellphone" label="工号"> </el-table-column> -->
              <el-table-column prop="cellphone" label="电话"></el-table-column>
              <el-table-column prop="email" label="邮箱"></el-table-column>
              <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
            </el-table>
          </div>
          <div class="tablePagesNumber">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="listQuery.PagingInfo.currentPage"
              :page-sizes="[10, 50, 100, 200]"
              :page-size="listQuery.PagingInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listQuery.PagingInfo.totalCount"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="组织机构"
      :visible.sync="organizationDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeOrganizationDialog()"
      :close-on-press-escape="false">
      <div class="modalForm">
        <el-form
        :show-message="false"
          :model="organizationInfo"
          label-position="left"
          ref="organizationForm"
          size="small"
          :rules="organizationRules"
          label-width="80px">
          <el-form-item label="名称:" prop="name">
            <el-input v-model="organizationInfo.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="numericalOrder">
            <el-input v-model="organizationInfo.numericalOrder" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="removeOrganization()" class="delete_btn" type="danger" plain v-if="organizationEditing==true&& organizationInfo.removed == false">停用</el-button>
        <el-button type="success" size="small" plain @click="recoverOrganization()" class="delete_btn" v-if="organizationEditing==true && organizationInfo.removed">恢复</el-button>
        <el-button size="small" @click="saveOrganization()">保存</el-button>
        <el-button size="small" @click="closeOrganizationDialog()">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="用户信息"
      :visible.sync="userDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeUserDialog()"
      :close-on-press-escape="false">
      <div class="modalForm">
        <el-form
         :show-message="false"
          :model="userInfo"
          label-position="left"
          ref="userInfo"
          size="small"
          :rules="userRules"
          label-width="100px">
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="userInfo.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="登录账户:" prop="account">
            <el-input v-model="userInfo.account" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password" v-if="userEditing==false">
            <el-input v-model="userInfo.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="passwordTemp" v-if="userEditing==true">
            <el-input v-model="userInfo.passwordTemp" autocomplete="off" placeholder="密码留空表示不修改密码"></el-input>
            <span></span>
          </el-form-item>
          <el-form-item label="邮件:" prop="email">
            <el-input v-model="userInfo.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话:" prop="cellphone">
            <el-input v-model="userInfo.cellphone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="组织机构:" prop="organizationName">
            <el-input v-model="userInfo.organizationName" autocomplete="off" readonly></el-input>
            <div class="input_chooseBtn">
              <el-button type="text" size="medium" @click="chooseUserOrganization">选择</el-button>
              <el-button type="text" size="medium" @click="clearUserOrganization">清除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="超级管理员:" prop="domainAdmin">
            <el-select v-model="userInfo.domainAdmin" placeholder="请选择">
              <el-option label="是" value="true"></el-option>
              <el-option label="否" value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" plain size="small" @click="removeUser()" class="delete_btn" v-if="userEditing==true && userInfo.removed == false">停用</el-button>
        <el-button type="success" size="small" plain @click="recoverUser()" class="delete_btn" v-if="userEditing==true && userInfo.removed">恢复</el-button>
        <el-button  size="small" @click="saveUser()">保存</el-button>
        <el-button  size="small" @click="closeUserDialog()">取消</el-button>
      </div>
    </el-dialog>

    <chooseOrganization ref="chooseOrganization" 
     :propsData="organizationChooseViewProps"
     @chooseOrganizationCallback="chooseOrganizationCallback">
     </chooseOrganization>

  </div>
</template>
<script>
import { hex_md5 } from "@/utils/MD5";
import chooseOrganization from "../common/chooseOrganization";
export default {
  name: "departmentName",
  components: {chooseOrganization},
  props: [],
  data() {

    var validatePass = (rule, value, callback) => {
      if (value === "") {
         callback(new Error("请输入密码；"));
      } 
      else if(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/g) == null) //强密码验证
      {
        //https://c.runoob.com/front-end/854/
        //强密码(必须包含大小写字母和数字的组合，可以使用特殊字符，长度在6-30之间)
        //^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,30}$

        callback(new Error("密码必须 8 位以上，至少包含大小写字母和数字；"));
      }

      callback();
    };

     var validatePass2 = (rule, value, callback) => {
      if (value === "" || value == null || value == undefined) {
         callback();
      } 
      else if(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/g) == null) //强密码验证
      {
        //https://c.runoob.com/front-end/854/
        //强密码(必须包含大小写字母和数字的组合，可以使用特殊字符，长度在6-30之间)
        //^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,30}$

        callback(new Error("密码必须 8 位以上，至少包含大小写字母和数字；"));
      }

      callback();
    };

    return {
      organizationChooseViewProps: {
        visible: false,
        includeRemoved:true
      },
      treeData: [],
      tree_key: 0,
      filterText: "",
      disabledTreeButtons: false,
      organizationDialogVisible: false,
      userDialogVisible: false,
      organizationEditing: false,
      userEditing: false,
      organizationInfo: {
        id: "",
        parentId: "",
        numericalOrder: 0,
        name: ""
      },
      currentOrganizationNode: "",
      userList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          organizationId: "",
          organizationIdPath: "",
          keyword: "",
          includeRemoved:true
        }
      },
      userInfo: {
        organizationId: "",
        account: "",
        password: "",
        name: "",
        email: "",
        cellphone: "",
        createTime: "",
        domainAdmin: "false",
        id: "",
        passwordTemp: "",
        organizationName: "",
      },
      organizationRules: {
        name: [{ required: true, message: "请输入名称", trigger: "change" }],
        numericalOrder: [
          { required: true, message: "请输入排序", trigger: "change" }
        ]
      },
      userRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "change" }],
        account: [{ required: true, message: "请输入登录账户", trigger: "change" }],
        // password: [
        //   { required: true, message: "请输入密码", trigger: "change" }
        // ],
        password: [{ validator: validatePass, trigger: "change" }],
        passwordTemp: [{ validator: validatePass2, trigger: "change" }],
        organizationName: [
          { required: true, message: "请选择组织机构", trigger: "change" }
        ]
      },
      organizationTreeProps: {
        children: "children",
        label: "name"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    this.getOrganizationTree();
  },
  methods: {
  
    getOrganizationTree() {
      this.$organizationApi.getOrganizationTree(null,true).then(res => 
      {
        this.treeData = [];
        if (res.data.successful) 
        {
          this.treeData = res.data.data;
          // this.listQuery.Parameters.organizationId = this.treeData[0].id
          this.listQuery.Parameters.organizationIdPath = res.data.data[0].id;

          this.currentOrganizationNode = res.data.data[0].id;
          this.getUserList();
        } 
        else 
        {
          this.$alert("获取组织机构失败！", "提示");
        }
      });
    },
    getOrganization(id) {
      //   let  dataObj = {id:id}
      this.$organizationApi.getOrganization(id).then(res => {
        if (res.data.successful) {
          this.organizationInfo = res.data.data;
        } else {
          this.$alert("获取组织机构失败！", "提示");
        }
      });
    },
    showOrganizationDialog() {
      this.organizationDialogVisible = true;
      if (!this.organizationInfo.id) {
        this.organizationInfo.parentId = this.treeData[0].id;
        this.organizationInfo.id = this.treeData[0].id;
      }
    },
    editOrganization() {
      this.organizationDialogVisible = true;
      this.organizationEditing = true;
      if (!this.organizationInfo.id) {
        this.organizationInfo.parentId = this.treeData[0].id;
        this.organizationInfo.id = this.treeData[0].id;
      }
      let id = this.organizationInfo.id;
      this.getOrganization(id);
    },
    saveOrganization() {
      this.$refs["organizationForm"].validate((valid,data) => {
        if (!valid){
          this.$uiHelper.showValidationMessage(valid,data);
          return;
        }

        let submitForm = JSON.parse(JSON.stringify(this.organizationInfo));

        if (this.organizationEditing) 
        {
          this.$organizationApi.updateOrganization(this.organizationInfo).then(res => 
          {
            if (res.data.successful) 
            {
              this.getOrganizationTree();
              this.organizationDialogVisible = false;
            } 
            else {
              this.$alert(res.data.message, "提示");
            }
          });
        } 
        else {
          delete submitForm.id;
          this.$organizationApi.createOrganization(submitForm).then(res => {
            if (res.data.successful) {
              this.getOrganizationTree();
              this.organizationDialogVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    removeOrganization() {
      this.$confirm("停用组织机构不影响历史周报和统计数据，依然可以正常查询统计。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.organizationInfo.id;
        this.$organizationApi.removeOrganization(id).then(res => {
          if (res.data.successful) {
            this.getOrganizationTree();
            this.organizationDialogVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    recoverOrganization(){
        this.$confirm("是否确认恢复该组织机构？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
          }).then(() => {
            let id = this.organizationInfo.id;
            this.$organizationApi.recoverOrganization(id).then(res => {
              if (res.data.successful) {
                this.getOrganizationTree();
                this.organizationDialogVisible = false;
              } else {
                this.$alert(res.data.message, "提示");
              }
            });
          });
    },
    closeOrganizationDialog() {
      this.$refs["organizationForm"].resetFields();
      this.organizationEditing = false;
      this.organizationDialogVisible = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    organizationTreeNodeClick(data) {
      this.disabledTreeButtons = false;
      this.organizationInfo.id = data.id;
      this.organizationInfo.parentId = data.id;
      this.organizationInfo.name = data.name;

      // this.listQuery.Parameters.organizationId=data.id;
      this.listQuery.Parameters.organizationIdPath = data.id;
      this.userInfo.organizationId = data.id;
      this.userInfo.organizationName = data.name;
      this.getUserList();
    },

    // 用户
    getUserList() {
      this.$userApi.getUserList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.userList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    getUser(data) {
      let id = data.id;
      this.$userApi.getUser(id).then(res => 
      {
        if (res.data.successful) 
        {
          this.userDialogVisible = true;
          this.userEditing = true;
          this.userInfo = res.data.data;
          if (this.userInfo.domainAdmin) 
          {
            this.userInfo.domainAdmin = "true";
          }
          else 
          {
            this.userInfo.domainAdmin = "false";
          }
        } 
        else
        {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    showUserDialog() {

      this.userInfo.organizationId = this.organizationInfo.id;
      this.userInfo.organizationName = this.organizationInfo.name;

      this.userDialogVisible = true;
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getUserList();
    },
    saveUser() {
      this.$refs["userInfo"].validate((valid,data) => 
      {
        if (!valid)
        {
           this.$uiHelper.showValidationMessage(valid,data);
           return;
        }
        let submitForm = JSON.parse(JSON.stringify(this.userInfo));
        if (this.userEditing) 
        {
          if (submitForm.passwordTemp && submitForm.passwordTemp != "") 
          {
            submitForm.password = hex_md5(submitForm.passwordTemp).toUpperCase();
          }
          this.$userApi.updateUser(submitForm).then(res => 
          {
            if (res.data.successful) 
            {
              this.getUserList();
              this.userDialogVisible = false;
            } 
            else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
        } 
        else 
        {
          delete submitForm.id;
          delete submitForm.removed;
          submitForm.password = hex_md5(submitForm.password).toUpperCase();
          this.$userApi.createUser(submitForm).then(res => 
          {
            if (res.data.successful) 
            {
              this.getUserList();
              this.userDialogVisible = false;
            } else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    removeUser() 
    {
      this.$confirm("停用的用户将不能再登录系统。但是不影响历史周报和统计数据，依然可以正常查询统计。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.userInfo.id;
        this.$userApi.removeUser(id).then(res => {
          if (res.data.successful) {
            this.getUserList();
            this.userDialogVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    recoverUser()
    {
        this.$confirm("恢复用户将其可以继续登录使用系统。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
        }).then(() => {
          let id = this.userInfo.id;
          this.$userApi.recoverUser(id).then(res => {
            if (res.data.successful) {
              this.getUserList();
              this.userDialogVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        });
    },
    closeUserDialog() {
      this.$refs["userInfo"].resetFields();
      this.resetObj(this.userInfo);
      this.userInfo.domainAdmin = "false";
      this.userEditing = false;
      this.userDialogVisible = false;
    },
    chooseUserOrganization() {
       this.$refs.chooseOrganization.show();
    },
    chooseOrganizationCallback(data) {
      this.userInfo.organizationId = data.id;
      this.userInfo.organizationName = data.name;
    },
    clearUserOrganization() {
      // this.chooseDialog = false;
      this.userInfo.organizationId = "";
      this.userInfo.organizationName = "";
    },
    resetObj(dataObj) {
      for (var i in dataObj) {
        dataObj[i] = "";
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.tree {
  width: 260px;
  float: left;
}
.rightDiv {
  width: calc(100% - 280px);
  float: right;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/organization.vue